// extracted by mini-css-extract-plugin
export default {"br":"Zq","w80":"ar","card":"br","wrapper":"cr","fullView":"er","profilePic":"fr","comment":"gr","animate":"hr","shimmer":"ir","square":"jr"};
    if(module.hot) {
      // 1737143653915
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  